<mat-drawer-container *ngIf = "deviceXl || deviceLg" class="example-container" autosize>
   <mat-drawer #drawer class="example-sidenav" mode="side" opened = "true" position = "end">
    <!-- <ng-scrollbar #scrollable pointerEventsMethod="scrollbar" [disabled]="disabled">
     -->
    <div class="header-container">
        <div>
            <i (click) = "navigateTo()" style="cursor: pointer;" class="material-icons">push_pin</i>
        </div>
        <div class="header-left-container">
            <h2 mat-dialog-title>Previous Meeting History</h2>
        </div>
        <div class="header-right-container">
            <mat-form-field  appearance="fill">
                <input type="text" matInput placeholder="search">
                <mat-icon matSuffix>search</mat-icon>
              </mat-form-field>
        </div>
    </div>
    <ng-scrollbar #scrollable pointerEventsMethod="scrollbar" [disabled]="disabled">
    <mat-dialog-content class="main-container">
        <div style="height: 600px;">
    <!-- <ng-scrollbar #scrollable pointerEventsMethod="scrollbar" [disabled]="disabled"> -->
            <cdk-accordion class="example-accordion"> 
                <cdk-accordion-item
                  #accordionItem="cdkAccordionItem">
                  <div class="example-accordion-item-header" (click)="accordionItem.toggle()">
                    <span class="example-accordion-item-description">
                        <mat-icon class="icon">{{accordionItem.expanded ? 'keyboard_arrow_down' : 'keyboard_arrow_right'}}</mat-icon>
                    </span>
                    <div class="accordion-header-container">
                        <div class="accordion-header-left-container">
                            <h2 class="accordion-title">Project Status Meeting</h2>
                            <p>{{currentDateTwo}}. at 2:00 PM for 60 minutes</p>
                        </div>
                    </div>
                  </div>
                  <div>
                    <ul class="un-order-list-container">
                        <li class="list-item">Lakshmi Kala M</li>
                        <li class="list-item">Shivakumar M</li>
                        <li class="list-item">Chandrasekar K</li>
                        <li class="list-item">3 More..</li>
                    </ul>
                </div>
                  <div>
                      <mat-list>
                        <mat-list-item>
                            <div class="list-item-container">
                                <div>
                                    <h2>Agenda - 1:</h2>
                                </div>
                                <div>
                                    <h3>Project status meeting</h3>
                                    <p>Description</p>
                                </div>      
                            </div>
                        </mat-list-item>
                      </mat-list>
                  </div>
                  <div
                    class="example-accordion-item-body"
                    role="region"
                    [style.display]="accordionItem.expanded ? '' : 'none'">
                        <div class="accordion-container">
                            <div class="accordion-left-container">
                                <div>
                                    <h3>Note</h3>
                                </div>
                                <div>
                                </div>
                            </div>
                            <div class="accordion-right-container">
                                <div>
                                    <h3>Task</h3>
                                </div>
                                <div>
                                </div>
                            </div>
                        </div>
                  </div>
                </cdk-accordion-item>
                <mat-divider></mat-divider>
            </cdk-accordion> 
            <!-- </ng-scrollbar>              -->
        </div>
    </mat-dialog-content>
    </ng-scrollbar>
   </mat-drawer>
   <div class="example-sidenav-content">
      <div class="left-container">
        <mat-card appearance="outlined" class="header-container">
            <div class="header-left-container">
                <h1 class="header-content">Agora Discussion ({{currentDate}})</h1>
            </div>
        </mat-card>
        <div class="description-header-container">
            <div class="desc-left-container">
                <mat-icon>calendar_today</mat-icon>
            </div>
            <div class="desc-right-container">
                <h2 class="description-content-container">Agora Discussion</h2>
            </div>
        </div>
        <div>
            <cdk-accordion class="example-accordion"> 
                
                <app-instant-meeting-description [useBool] = "boolean"></app-instant-meeting-description>
                <mat-divider></mat-divider>
                <app-instant-participants></app-instant-participants>
                <mat-divider></mat-divider>
                <app-instant-meeting-agenda></app-instant-meeting-agenda>
            </cdk-accordion> 
        </div>
      </div>
      <div class="right-container">
        <button type="button" mat-button (click)="drawer.toggle()">
            <mat-icon>keyboard_arrow_left</mat-icon>
        </button>
      </div>
      <div class="example-box" cdkDrag>
        video
      </div>
   </div>
</mat-drawer-container>
<div fxLayout.xs="column" fxLayout.sm="column" fxLayout.md="column" *ngIf = "deviceMd || deviceSm || deviceXs">
    <div>
        <div>
          <mat-card appearance="outlined" class="header-container" [ngStyle.xs] = "{
            height : 'auto'
         }">
              <div class="header-left-container">
                  <h1 class="header-content" [ngStyle.xs] = "{
                    'font-size.px' : 15
                 }">Agora Discussion ({{currentDate}})</h1>
              </div>
          </mat-card>
          <div class="description-header-container" [ngStyle.xs] = "{
            'margin.px' : 0,
            'margin-top.px' : 10
         }">
              <div class="desc-left-container">
                  <mat-icon [ngStyle.xs] = "{
                    'font-size.px' : 15
                 }">calendar_today</mat-icon>
              </div>
              <div class="desc-right-container" [ngStyle.xs] = "{
                'padding-left.px' : 0
             }">
                  <h2 class="description-content-container" [ngStyle.xs] = "{
                    'font-size.px' : 15,
                    'margin-top.px' : -5
                 }">Agora Discussion</h2>
              </div>
          </div>
          <div>
              <cdk-accordion class="example-accordion"> 
                  
                  <app-instant-meeting-description [useBool] = "boolean"></app-instant-meeting-description>
                  <mat-divider></mat-divider>
                  <app-instant-participants></app-instant-participants>
                  <mat-divider></mat-divider>
                  <app-instant-meeting-agenda></app-instant-meeting-agenda>
              </cdk-accordion> 
          </div>
        </div>
        <div class="example-box" cdkDrag>
          video
        </div>
    </div>
    <div>
        <div class="header-container">
            <div>
                <i (click) = "navigateTo()" style="cursor: pointer;" class="material-icons">push_pin</i>
            </div>
            <div class="header-left-container" style="width: 35%;">
                <h2 mat-dialog-title>Previous Meeting History</h2>
            </div>
            <div class="header-right-container" style="width: 50%;">
                <mat-form-field  appearance="fill">
                    <input type="text" matInput placeholder="search">
                    <mat-icon matSuffix>search</mat-icon>
                  </mat-form-field>
            </div>
        </div>
        <!-- <ng-scrollbar #scrollable pointerEventsMethod="scrollbar" [disabled]="disabled"> -->
        <div class="main-container">
            <div style="height: 600px;">
              <!-- <ng-scrollbar #scrollable pointerEventsMethod="scrollbar" [disabled]="disabled"> -->
                <cdk-accordion class="example-accordion"> 
                    <cdk-accordion-item
                      #accordionItem="cdkAccordionItem">
                      <div class="example-accordion-item-header" (click)="accordionItem.toggle()">
                        <span class="example-accordion-item-description">
                            <mat-icon class="icon">{{accordionItem.expanded ? 'keyboard_arrow_down' : 'keyboard_arrow_right'}}</mat-icon>
                        </span>
                        <div class="accordion-header-container">
                            <div class="accordion-header-left-container">
                                <h2 class="accordion-title">Project Status Meeting</h2>
                                <p>{{currentDateTwo}}. at 2:00 PM for 60 minutes</p>
                            </div>
                        </div>
                      </div>
                      <div>
                        <ul class="un-order-list-container">
                            <li class="list-item">Lakshmi Kala M</li>
                            <li class="list-item">Shivakumar M</li>
                            <li class="list-item">Chandrasekar K</li>
                            <li class="list-item">3 More..</li>
                        </ul>
                    </div>
                      <div>
                          <mat-list>
                            <mat-list-item>
                                <div class="list-item-container">
                                    <div>
                                        <h2>Agenda - 1:</h2>
                                    </div>
                                    <div>
                                        <h3>Project status meeting</h3>
                                        <p>Description</p>
                                    </div>      
                                </div>
                            </mat-list-item>
                          </mat-list>
                      </div>
                      <div
                        class="example-accordion-item-body"
                        role="region"
                        [style.display]="accordionItem.expanded ? '' : 'none'">
                            <div class="accordion-container">
                                <div class="accordion-left-container">
                                    <div>
                                        <h3>Note</h3>
                                    </div>
                                    <div>
                                    </div>
                                </div>
                                <div class="accordion-right-container">
                                    <div>
                                        <h3>Task</h3>
                                    </div>
                                    <div>
                                    </div>
                                </div>
                            </div>
                      </div>
                    </cdk-accordion-item>
                    <mat-divider></mat-divider>
                </cdk-accordion> 
               <!-- </ng-scrollbar>              -->
            </div>
        </div>
        <!-- </ng-scrollbar> -->
    </div>
</div>